/** Select Multiple Segment
 *
 *  See bottom for ouput
 */
import { v4 as uuidv4 } from 'uuid'

import type { IQuestionSegmentData } from '@unionco/alaris-app-types'

import {
  selectMultipleDoubleColumnFixture,
  selectMultipleSingleColumnFixture
} from '@fixtures/phase/questionnaire/question'

export const selectMultipleSegmentFixture = {
  title: 'Segmet 2: Multi Select',
  introCopy: 'Progression based intro copy',
  status: {
    percent: 0,
    statusText: 'notStarted'
  },
  questions: [
    selectMultipleSingleColumnFixture,
    selectMultipleDoubleColumnFixture
  ],
  key: uuidv4(),
  type: 'questionSegment',
  isAlarisOnly: false,
  isActive: true
} as IQuestionSegmentData

/** Output
 {
    segmentTitle: 'Segmet 2: Multi Select',
    introCopy: 'Progression based intro copy',
    status: {
        percent: 0,
        statusText: 'notStarted'
    } as ISectionStatus,
    questions: [
    {
        answers: [
        {
            label: 'Select Multiple Answer 1',
            value: 'answer1'
        },
        {
            label: 'Select Multiple Answer 2',
            value: 'answer2'
        }
        ],
        answered: false,
        questionType: 'selectMultiple',
        questionText: 'Select Multiple 1 Column Layout Question?',
        selectedAnswer: null
    },
    {
        answers: [
        {
            label: 'Select Multiple Answer 1',
            value: 'answer1'
        },
        {
            label: 'Select Multiple Answer 2',
            value: 'answer2'
        },
        {
            label: 'Select Multiple Answer 3',
            value: 'answer3'
        },
        {
            label: 'Select Multiple Answer 4',
            value: 'answer4'
        }
        ],
        answered: false,
        questionType: 'selectMultiple',
        questionText: 'Select Multiple 2 Column Layout Question?',
        selectedAnswer: null
    }
    ]
}
*/
